import type { ApiDisplayLogic } from '../../../../internalTypes';
import type { AnswerLogic } from '../../../../types/survey';
import { mapLogicFilterGroup } from './mapLogicFilters';

export function mapAnswerLogic(raw: ApiDisplayLogic | undefined): AnswerLogic | undefined {
  if (!raw) {
    return undefined;
  }

  const condition = mapLogicFilterGroup(raw.condition);
  if (!condition) {
    return undefined;
  }

  return { condition };
}
